import React from 'react'
import styles from './PopupButtons.module.css'

type Props = {
    children?: React.ReactNode
}

export const PopupButtons: React.FC<Props> = ({children}) => {
    return (
        <div className={styles.buttons}>
            {
                React.Children.map(children, (child) => (
                    <div className={styles.button}>{child}</div>
                ))
            }
        </div>
    )
}
